import { ContainerListModal } from '../../design-system';
import { DashboardFormWrapper } from '../dashboard';
import { GateInsPage } from './GateInsComponents';
import { GateInsAddHeader, GateInsAddForm } from './GateInsAddComponents';
import { RoleGuard } from '../../routes';

export const GateInsAdd = () => {
  return (
    <RoleGuard roles={['YARD_COMPANY_VIEWER']} negative>
      <RoleGuard roles={['TRADER']} isMobile negative>
        <GateInsPage>
          <GateInsAddHeader />
          <DashboardFormWrapper flow={'row'}>
            <GateInsAddForm />
            <GateInsAddHeader showOnlySubmit />
          </DashboardFormWrapper>
        </GateInsPage>
        <ContainerListModal />
      </RoleGuard>
    </RoleGuard>
  );
};
